<template>
  <div id="productimages">
    <div class="contentText" v-html="(this.$root.language.wsm_proHeadText)"> 
    </div>
    <div>  
      <ProductList
      :translations = "this.$root.language"
      :settings = "this.$root.settings"
      :flaptype = "this.$root.flaptype"
      :hidecat = "this.$root.hidecat"
      />
    </div>
  </div>
</template>

<script>

  import ProductList from './components/ProductList.vue';

  export default {
    name : 'ProductImages',
    components : {
      ProductList
    },
  }
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50; 
    p{
      font-size: 15px;
    }
  }
  #productimages {
    max-width:100%;
    .contentText{
      a{
        margin-bottom: 20px;
      }
    }
  }
</style>
